import { FolderOverviewSelectors, FolderScopesSelectors } from '../store/selectors'
import { Observable, combineLatest, map } from 'rxjs'

import { BootstrapSelectors } from '@app/core/store/selectors/bootstrap.selector'
import { CdnConfig } from '@app/core/model/cdn-config.model'
import { Component } from '@angular/core'
import { FolderOverviewMappingService } from '../store/services/folder-overview-mapping.service'
import { FolderScopeDetails } from '../store'
import { FolderScopesActions } from '../store/actions/folder-scopes.actions'
import { FolderVersion } from '@app/core/model/folder-version.model'
import { Store } from '@ngrx/store'

@Component({
  selector: 'folder-overview-folder-container',
  template: `
    <folder-overview-folder
      [folder]="folder$ | async"
      [tableConfig]="folderScopesConfig$ | async"
      [scopeDetailsMap]="scopeDetailsMap$ | async"
      [cdnConfig]="cdnConfig$ | async" />
  `,
})
export class FolderOverviewFolderContainerComponent {
  folder$: Observable<FolderVersion> = this.store$.select(FolderOverviewSelectors.selectFolder)
  scopeDetailsMap$: Observable<FolderScopeDetails> = this.store$.select(FolderScopesSelectors.selectScopeDetailsMap)
  cdnConfig$: Observable<CdnConfig> = this.store$.select(BootstrapSelectors.selectCdnConfig)

  folderScopesConfig$ = combineLatest([
    this.store$.select(FolderScopesSelectors.selectIsLoadingTable),
    this.store$.select(FolderOverviewSelectors.selectScopes),
    this.store$.select(FolderScopesSelectors.selectColumns),
    this.store$.select(FolderScopesSelectors.selectDisplayedColumns),
    this.store$.select(FolderOverviewSelectors.selectRetainedHoursStats),
  ]).pipe(
    map(([isLoading, scopes, columns, displayedColumns, retainedHoursStats]) => ({
      isLoading,
      columns,
      displayedColumns,
      mappedDataSource: this.folderOverviewMappingService.mapScopes(scopes, columns, retainedHoursStats),
    }))
  )

  constructor(
    private store$: Store,
    private folderOverviewMappingService: FolderOverviewMappingService
  ) {
    this.store$.dispatch(FolderScopesActions.getColumnPreference())
  }
}
